import { atomWithStorage } from 'jotai/utils'
import { atom } from 'jotai';
import { LastWatchedExt } from '@shared/types';

export const compactModeAtom = atomWithStorage('compactMode', false, undefined, { getOnInit: true });
export const loadingShowIdsAtom = atom<Set<string>>(new Set<string>());
export const loadingProgressItemAtom = atom<LastWatchedExt | null>(null);
export const localLoadingShowIdsAtom = atom<Set<string>>(new Set<string>());
export const localLoadingProgressItemAtom = atom<LastWatchedExt | null>(null);
